import { useEffect } from "react";

/**
 * Per-route <title> + meta description updater. Small utility to keep the
 * head in sync when the SPA routes change — helps Google understand each
 * page as a distinct destination.
 */
export const useSEO = ({ title, description, canonical } = {}) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);

      // Also mirror to OG description for social previews
      let og = document.querySelector('meta[property="og:description"]');
      if (og) og.setAttribute("content", description);

      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle && title) ogTitle.setAttribute("content", title);
    }
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [title, description, canonical]);
};

export default useSEO;
